<template>
  <div class="video-card" v-if="video">
    <router-link :to="this.playButton ? {} : videoLink" style="display: block">
      <div class="thumb" @click="onClick">
        <img :src="getThumbnail(video)">
        <div class="duration">
          {{ formatDuration(video) }}
        </div>
        <div class="play" v-if="this.playButton">
          <div class="play-button"><font-awesome-icon icon="play"/></div>
        </div>
      </div>
    </router-link>
    <div class="info">
      <div class="publish-date" v-if="showDate">
        {{ formatDate }}<span v-if="showPrivate && isPrivate" class="private">(private)</span>
      </div>
      <div class="title">
        <router-link class="link" :to="videoLink">{{ video.title }}</router-link>
      </div>
      <div class="artist-name" v-if="showArtist">
        <router-link class="link" :to="{name: 'artist-about', params: { artistId: video.artist.id } }">{{ video.artist.name }}</router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .video-card {
    /* width: 22%; */
    margin: 11px;
    font-size: 0.8em;

    &.horizontal {
      display: flex;
      align-items: center;
      font-size: 1em;

      .thumb {
        /* margin-right: 1em; */
      }

      .publish-date, .artist-name {
        font-size: 0.8em;
      }
      .info {
        padding-top: 0;
        padding-left: 1em;
      }
      @include media-breakpoint-down(xs) {
        .info {
          padding-left: 1em;
        }
      }
    }

    .thumb {
      height: $video-height / 2.4;
      width: $video-width / 2.4;
      margin-bottom: 5px;
      position: relative;

      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      background: #000;

      img {
        height: $video-height / 2.4;
        width: $video-width / 2.4;
      }
      @include media-breakpoint-down(md) {
        height: $video-height / 2.8;
        width: $video-width / 2.8;
        img {
          height: $video-height / 2.8;
          width: $video-width / 2.8;
        }
      }
      @include media-breakpoint-down(sm) {
        height: $video-height / 3.5;
        width: $video-width / 3.5;
        img {
          height: $video-height / 3.5;
          width: $video-width / 3.5;
        }
      }
      @include media-breakpoint-down(xs) {
        height: $video-height / 3.8;
        width: $video-width / 3.8;
        img {
          height: $video-height / 3.8;
          width: $video-width / 3.8;
        }
      }
      @media screen and (max-width: 360px) {
        height: $video-height / 4.7;
        width: $video-width / 4.7;
        img {
          height: $video-height / 4.7;
          width: $video-width / 4.7;
        }
      }

      .play {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .play-button {
          width: 3em;
          height: 3em;
          text-align: center;
          line-height: 3.2em;
          font-size: 1.2rem;
          border-radius: 100%;
          background: rgba(0, 0, 0, 0.5);
          color: white;
        }
      }

      .duration {
        position: absolute;
        left: 5px;
        bottom: 5px;
        background: $black;
        color: $white;
        opacity: 0.5;
        padding: 3px 7px 3px 7px;
        font-size: 0.6em;
        border-radius: 2px;
      }
    }

    .info {
      max-width: $video-width / 2.4;
      overflow: hidden;

      padding-top: 1em;
      .publish-date, .artist-name .link {
        color: $steel;

        .private {
          margin-left: 0.5em;
        }
      }
      .title .link {
        color: $white;
        font-weight: bold;
      }
      .title {
      }
      .artist-name {
      }
      .album {
        color: $steel;
      }
    }
    @include media-breakpoint-down(xs) {
      font-size: 0.9em;
      .info {
        padding-left: 0em;
        padding-top: 0;
      }
    }
    @include media-breakpoint-down(md) {
      .info {
        max-width: $video-width / 2.8;
      }
    }
    @include media-breakpoint-down(sm) {
      .info {
        max-width: $video-width / 3.5;
      }
    }
    @include media-breakpoint-down(xs) {
      .info {
        max-width: $video-width / 3.8;
      }
    }
    @media screen and (max-width: 360px) {
      .info {
        max-width: $video-width / 4.7;
      }
    }
  }

  @media screen and (max-width: 400px) {
    .video-card.collapse {
      justify-content: center;

      .info {
        width: 50%;
        padding-top: 0;
      }
    }
  }

</style>

<script>
import moment from '@/utils/moment'
import map from 'lodash/map'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import { songHelpers } from '@/store/helpers'

export default {
  name: 'VideoCard',
  components: {
    FontAwesomeIcon
  },
  props: {
    video: Object,
    showDate: Boolean,
    showArtist: Boolean,
    showPrivate: Boolean,
    related: Array,
    playButton: Boolean,
    linkToEditor: Boolean
  },
  computed: {
    formatDate () {
      if (!this.video) return ''
      return moment(this.video.created_at).format('MM/DD/YYYY')
    },
    videoLink () {
      if (this.linkToEditor) {
        return {name: 'artist-video-edit', params: {id: this.video.id}}
      } else {
        return {name: 'video-detail', params: {id: this.video.id}, query: this.relatedQuery}
      }
    },
    relatedQuery () {
      if (!this.related) return {}
      return {
        related: map(this.related, 'id').join(',')
      }
    },
    isPrivate () {
      if (!this.video) return false
      return this.video.video_visibility === 'private'
    }
  },
  methods: {
    onClick () {
      if (this.playButton) this.$emit('play')
    },
    ...songHelpers
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/VideoCard.vue